import { ReactComponent as MasterCardIcon } from 'icons/Mastercard.svg';
import { ReactComponent as VisaIcon } from 'icons/Visa.svg';
import { ReactComponent as AmexIcon } from 'icons/Amex.svg';
import { ReactComponent as AliPayIcon } from 'icons/Alipay.svg';
import { ReactComponent as UnionPayIcon } from 'icons/UnionPay.svg';
import { ReactComponent as WeChatIcon } from 'icons/WeChat.svg';
import { ReactComponent as PayPalIcon } from 'icons/PayPal.svg';
import { ReactComponent as ApplePayIcon } from 'icons/ApplePay.svg';
import { ReactComponent as PostPayIcon } from 'icons/postepay.svg';
import { ReactComponent as SatisPayIcon } from 'icons/SatisPay.svg';
import { ReactComponent as KlarnaIcon } from 'icons/klarna.svg';
import { ReactComponent as ScalapayIcon } from 'icons/scalapay.svg';

import { useTranslation } from 'react-i18next';
import {
  Checkbox as AntdCheckbox,
  Col,
  Divider,
  Row,
  Form,
  Select as AntSelect,
} from 'antd';
import { RadioItem, RadioItemInfo, FlexBox } from './styled';
import { Input, Checkbox, Select } from './index';
import React from 'react';

const PaymentsAccept = ({ form }) => {
  const { t } = useTranslation();
  const items = [
    {
      id: 1,
      name: 'company_data_attributes.payment_mastercard',
      icon: MasterCardIcon,
      label: 'Mastercard',
    },
    {
      id: 2,
      name: 'company_data_attributes.payment_visa',
      icon: VisaIcon,
      label: 'Visa',
    },
    {
      id: 3,
      name: 'company_data_attributes.payment_american_express',
      icon: AmexIcon,
      label: 'American Express',
    },
    {
      id: 4,
      name: 'company_data_attributes.payment_alipay',
      icon: AliPayIcon,
      label: 'Ali Pay',
      checked: true,
    },
    {
      id: 5,
      name: 'company_data_attributes.payment_union_pay',
      icon: UnionPayIcon,
      label: 'Union Pay',
    },
    {
      id: 6,
      name: 'company_data_attributes.payment_wechat_pay',
      icon: WeChatIcon,
      label: 'Wechat Pay',
    },
    {
      id: 7,
      name: 'company_data_attributes.payment_paypal',
      icon: PayPalIcon,
      label: 'PayPal',
    },
    {
      id: 8,
      name: 'company_data_attributes.payment_apple_pay',
      icon: ApplePayIcon,
      label: 'Apple Pay',
    },
    {
      id: 9,
      name: 'company_data_attributes.payment_poste_pay',
      icon: PostPayIcon,
      label: 'PostePay',
    },
    {
      id: 10,
      name: 'company_data_attributes.payment_satispay',
      icon: SatisPayIcon,
      label: 'SatisPay',
    },
    {
      id: 11,
      name: 'company_data_attributes.payment_klarna',
      icon: KlarnaIcon,
      label: 'Klarna',
    },
    {
      id: 12,
      name: 'company_data_attributes.payment_scalapay',
      icon: () => (
        <>
          <img src='/images/scalapay.png' alt={'scalapay'} />
        </>
      ),
      label: 'Scalapay',
    },
  ];

  const val1 = Form.useWatch(
    'company_data_attributes.payment_mastercard',
    form,
  );

  const val2 = Form.useWatch('company_data_attributes.payment_visa', form);
  const val3 = Form.useWatch(
    'company_data_attributes.payment_american_express',
    form,
  );
  const val4 = Form.useWatch('company_data_attributes.payment_alipay', form);
  const val5 = Form.useWatch('company_data_attributes.payment_union_pay', form);
  const val6 = Form.useWatch(
    'company_data_attributes.payment_wechat_pay',
    form,
  );
  const val7 = Form.useWatch('company_data_attributes.payment_paypal', form);
  const val8 = Form.useWatch('company_data_attributes.payment_apple_pay', form);
  const val9 = Form.useWatch('company_data_attributes.payment_poste_pay', form);
  const val10 = Form.useWatch('company_data_attributes.payment_satispay', form);
  const val11 = Form.useWatch('company_data_attributes.payment_klarna', form);
  const val12 = Form.useWatch('company_data_attributes.payment_scalapay', form);

  const checkboxValues = {
    'company_data_attributes.payment_mastercard': val1,
    'company_data_attributes.payment_visa': val2,
    'company_data_attributes.payment_american_express': val3,
    'company_data_attributes.payment_alipay': val4,
    'company_data_attributes.payment_union_pay': val5,
    'company_data_attributes.payment_wechat_pay': val6,
    'company_data_attributes.payment_paypal': val7,
    'company_data_attributes.payment_apple_pay': val8,
    'company_data_attributes.payment_poste_pay': val9,
    'company_data_attributes.payment_satispay': val10,
    'company_data_attributes.payment_klarna': val11,
    'company_data_attributes.payment_scalapay': val12,
  };

  return (
    <Row gutter={[0, 24]}>
      <Col span={24}>
        {/*<RadioWrapper>*/}
        <Row gutter={[24, 0]}>
          {items.map(({ icon: Icon, ...item }) => (
            <Col key={item.id} span={8}>
              <Form.Item name={item.name} valuePropName='checked'>
                <RadioItem as='label'>
                  <RadioItemInfo>
                    {Icon && <Icon />}
                    <span>{item.label}</span>
                  </RadioItemInfo>
                  <AntdCheckbox checked={checkboxValues[item.name]} />
                </RadioItem>
              </Form.Item>
            </Col>
          ))}
        </Row>

        {/*</RadioWrapper>*/}
      </Col>
      <Col span={24}>
        <Divider style={{ margin: 0 }} />
      </Col>
      <Col span={24}>
        <Row gutter={[12, 12]} align='bottom'>
          <Col span={12}>
            <Form.Item name='company_data_attributes.tax_free'>
              <Select
                label={t('Operatore tax free')}
                size='large'
                placeholder={t('Selezioni opzione')}
                optionFilterProp='children'
                name='company'
              >
                <AntSelect.Option value=''>
                  {t('Selezioni opzione')}
                </AntSelect.Option>
                <AntSelect.Option value='global_blue'>
                  Global Blue
                </AntSelect.Option>
                <AntSelect.Option value='planet'>Planet</AntSelect.Option>
                <AntSelect.Option value='tax_free'>Tax free</AntSelect.Option>
              </Select>
            </Form.Item>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default PaymentsAccept;
